"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _accordion = require("../accordion");

var _tabs = require("../tabs");

var _widgetInfo = _interopRequireDefault(require("../widget-info"));

var _orderValues = _interopRequireDefault(require("../order-values"));

var _queryLimit = _interopRequireDefault(require("../query-limit"));

var _filter = _interopRequireDefault(require("../filter"));

var _endUserFilters = _interopRequireDefault(require("../end-user-filters"));

var _styleConstants = require("@widget-editor/shared/lib/styles/style-constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AdvancedEditor = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../advanced-editor"));
  });
});

var TableView = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../table-view"));
  });
});

var Typography = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../typography"));
  });
});

var ColorSchemes = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../color-schemes"));
  });
});

var DonutRadius = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../donut-radius"));
  });
});

var SliceCount = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../slice-count"));
  });
});

var MapInfo = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../map-info"));
  });
});

var StyleEditorOptionsInfo = _styledComponents["default"].div.withConfig({
  displayName: "component__StyleEditorOptionsInfo",
  componentId: "ici61l-0"
})(["position:absolute;left:50%;bottom:50%;transform:translate(-50%,-50%);h3{color:", ";text-align:center;}p{color:#bfbfbf;font-size:12px;}"], function (props) {
  return props.color || "#ff6464";
});

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "component__StyledContainer",
  componentId: "ici61l-1"
})(["position:relative;flex:1;padding:0 0 0 30px;margin:10px 0;height:calc(100% - 20px);overflow-y:hidden;", " ", " ", ""], (0, _styleConstants.DEFAULT_BORDER)(1, 1, 1, 0), function (props) {
  return (props.compact.isCompact || props.compact.forceCompact) && (0, _styledComponents.css)(["visibility:hidden;max-height:0;position:absolute;top:65px;left:0;margin:0;width:100%;background:#fff;transition:all 0.3s ease-in-out;"]);
}, function (props) {
  return (props.compact.isCompact || props.compact.forceCompact) && props.compact.isOpen && (0, _styledComponents.css)(["box-sizing:border-box;display:block;z-index:2;visibility:visible;max-height:calc(100% - ", " - 65px);"], _styleConstants.FOOTER_HEIGHT);
});

var EditorOptions = function EditorOptions(_ref) {
  var initialized = _ref.initialized,
      restoring = _ref.restoring,
      advanced = _ref.advanced,
      rasterOnly = _ref.rasterOnly,
      disabledFeatures = _ref.disabledFeatures,
      datasetId = _ref.datasetId,
      limit = _ref.limit,
      donutRadius = _ref.donutRadius,
      sliceCount = _ref.sliceCount,
      data = _ref.data,
      orderBy = _ref.orderBy,
      patchConfiguration = _ref.patchConfiguration,
      compact = _ref.compact,
      dataService = _ref.dataService,
      isMap = _ref.isMap;
  var handleSliceCount = (0, _debounce["default"])(function (value) {
    patchConfiguration({
      sliceCount: parseInt(value)
    });
  }, 500);
  var handleDonutRadius = (0, _debounce["default"])(function (value) {
    patchConfiguration({
      donutRadius: parseInt(value)
    });
  }, 500);

  var handleOrderBy = function handleOrderBy(value) {
    patchConfiguration({
      orderBy: value
    });
  };

  var handleGroupBy = function handleGroupBy(value) {
    patchConfiguration({
      groupBy: value
    });
  };

  var handleLimit = (0, _debounce["default"])(function (value) {
    patchConfiguration({
      limit: value
    });
  }, 500);

  if (!initialized || restoring) {
    return _react["default"].createElement(StyledContainer, {
      compact: compact
    }, _react["default"].createElement(StyleEditorOptionsInfo, {
      color: "#8c8c8c"
    }, _react["default"].createElement("h3", null, "Loading settings...")));
  }

  if (!datasetId && initialized && !restoring) {
    return _react["default"].createElement(StyledContainer, {
      compact: compact
    }, _react["default"].createElement(StyleEditorOptionsInfo, null, _react["default"].createElement("h3", null, "Error loading dataset"), _react["default"].createElement("p", null, "Dataset not accessible at this moment.")));
  }

  return _react["default"].createElement(StyledContainer, {
    compact: compact
  }, _react["default"].createElement(_tabs.Tabs, null, _react["default"].createElement(_tabs.Tab, {
    id: "general",
    label: "General"
  }, _react["default"].createElement(_accordion.Accordion, null, _react["default"].createElement(_accordion.AccordionSection, {
    title: "Description and labels",
    openDefault: true
  }, _react["default"].createElement(_widgetInfo["default"], {
    isMap: isMap
  })), !isMap && !advanced && _react["default"].createElement(_accordion.AccordionSection, {
    title: "Filters"
  }, _react["default"].createElement(_filter["default"], {
    dataService: dataService
  })), !isMap && !advanced && disabledFeatures.indexOf("end-user-filters") === -1 && _react["default"].createElement(_accordion.AccordionSection, {
    title: "End-user filters"
  }, _react["default"].createElement(_endUserFilters["default"], null)), !isMap && !advanced && _react["default"].createElement(_accordion.AccordionSection, {
    title: "Order"
  }, _react["default"].createElement(_orderValues["default"], {
    onChange: function onChange(value) {
      return handleOrderBy(value);
    }
  }), limit !== undefined && limit !== null && _react["default"].createElement(_queryLimit["default"], {
    min: 0,
    max: 500,
    onChange: handleLimit,
    label: "Limit",
    value: limit
  })), !isMap && !rasterOnly && !advanced && _react["default"].createElement(_accordion.AccordionSection, {
    title: "Chart specific"
  }, _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, donutRadius && _react["default"].createElement(DonutRadius, {
    value: donutRadius,
    onChange: function onChange(value) {
      return handleDonutRadius(value);
    }
  })), _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, sliceCount && data && _react["default"].createElement(SliceCount, {
    value: sliceCount,
    data: data,
    onChange: function onChange(value) {
      return handleSliceCount(value);
    }
  }))))), isMap && _react["default"].createElement(_tabs.Tab, {
    id: "map",
    label: "Map"
  }, _react["default"].createElement(_accordion.Accordion, null, _react["default"].createElement(_accordion.AccordionSection, {
    title: "Configuration",
    openDefault: true
  }, _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, _react["default"].createElement(MapInfo, null))))), !isMap && !advanced && _react["default"].createElement(_tabs.Tab, {
    id: "style",
    label: "Visual style"
  }, _react["default"].createElement(_accordion.Accordion, null, disabledFeatures.indexOf("typography") === -1 && _react["default"].createElement(_accordion.AccordionSection, {
    title: "Typography"
  }, _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, _react["default"].createElement(Typography, null))), disabledFeatures.indexOf("theme-selection") === -1 && _react["default"].createElement(_accordion.AccordionSection, {
    title: "Color scheme",
    openDefault: disabledFeatures.indexOf("typography") !== -1
  }, _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, _react["default"].createElement(ColorSchemes, null))))), disabledFeatures.indexOf("advanced-editor") === -1 && !isMap && _react["default"].createElement(_tabs.Tab, {
    id: "advanced",
    label: "Advanced"
  }, _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, _react["default"].createElement(AdvancedEditor, null))), disabledFeatures.indexOf("table-view") === -1 && !isMap && !advanced && _react["default"].createElement(_tabs.Tab, {
    id: "table",
    label: "Table view"
  }, _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, _react["default"].createElement(TableView, null)))));
};

var _default = EditorOptions;
exports["default"] = _default;